export default __webpack_public_path__ + "static/media/X_Xui.52708b4f.mp3";